"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Document = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Document.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Document = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['document']
  }, props.link ? /*#__PURE__*/React.createElement("a", {
    className: styles['link'],
    href: props.link,
    rel: "noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: styles['type']
  }, /*#__PURE__*/React.createElement(_icons.IconFilePdf16, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, props.title)), props.subtitle && /*#__PURE__*/React.createElement("div", {
    className: styles['subtitle']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: props.isActual ? 'gray40_100' : 'text-warning-default'
  }, props.subtitle)), /*#__PURE__*/React.createElement("i", {
    "aria-hidden": "true",
    className: styles['icon']
  }, /*#__PURE__*/React.createElement(_icons.IconActionExternaLInk16, null))) : /*#__PURE__*/React.createElement("div", {
    className: styles['link']
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: styles['type']
  }, /*#__PURE__*/React.createElement(_icons.IconFilePdf16, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, props.title)), props.subtitle && /*#__PURE__*/React.createElement("div", {
    className: styles['subtitle']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: props.isActual ? 'gray40_100' : 'text-warning-default'
  }, props.subtitle))));
};
exports.Document = Document;